import React, {useEffect} from 'react'
import { Button } from 'reactstrap'
import {FormattedMessage} from "react-intl"
import { connect } from 'react-redux'
import {CloseMenuIcon, InfoIcon, OpenMenuIcon, SupportIcon} from 'config/icons'
import RightActions from 'components/lpui/layout/TopBar/RightActions'
import UserMenu from './UserMenu'
import style from './style.module.scss'
import { ModalContainer } from '../../../../dev/ModalContainer'
import Updates from './Updates'
import {documentationLinks} from './documentationLinks.tsx'
import {TooltipIcon} from "../../../platform/Table/TooltipIcon";

/* import Actions from "./Actions";

 <div className="mr-4 d-none d-sm-block">
        <Actions />
      </div>
   <div className="mr-4 d-none d-sm-block">
        <LanguageSwitcher />
      </div>
* */

const TopBar = ({ isMenuCollapsed, dispatch, location }) => {
  const [documentationLink, setDocumentationLink] = React.useState('')
  const onCollapse = () => {
    /* if (type === 'responsive' && isMenuCollapsed) {
      return
    } */
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'isMenuCollapsed',
        value: !isMenuCollapsed,
      },
    })
  }

  useEffect(() => {
    const defaultLink = documentationLinks[location.pathname.split('/')[1]]
    const searchParams = new URLSearchParams(location.search)
    const tab = searchParams.get('tab')
    console.log("Tab", tab)
    if(tab){
      const link = documentationLinks[tab] || defaultLink
      setDocumentationLink(link)
      return
    }
    if(location.pathname.split("/").pop() === "dashboard"){
      setDocumentationLink(documentationLinks["candidates.dashboard"])
      return
    }
    const link = location.pathname.includes('interview') ?
      documentationLinks.interview :
      defaultLink
    setDocumentationLink(link)
  }, [location])

  return (
    <div className={style.topbar}>
      <div className="mr-4 d-none d-sm-block">
        <Button
          style={{ width: 49, lineHeight: 1, padding: '7px 10px' }}
          onClick={onCollapse}
          color={'primary'}
        >
          {isMenuCollapsed ? <OpenMenuIcon style={{ fontSize: 17 }} /> : <CloseMenuIcon />}
        </Button>
      </div>
      <div id={'headerbar-root'} className={`${style.topbarLeft} mr-auto`} />

      {process.env.NODE_ENV === 'development' && (
        <div className="mr-4 d-none d-sm-block">
          <ModalContainer />
        </div>
      )}
      <div className="mr-4 d-none d-sm-block">
        <TooltipIcon
          href={documentationLink}
          target={'_blank'}
          rel="noopener noreferrer"
          title={<FormattedMessage id='global.guide' />}
          Icon={InfoIcon}
          className={style.icon}
        />
      </div>
      <div className="mr-4 d-none d-sm-block">
        <a rel={"noreferrer"} target={"_blank"} href={'https://performa.atlassian.net/servicedesk/customer/portal/1'}>
          <TooltipIcon
            href={process.env.REACT_APP_URL_SUPPORT}
            target={'_blank'}
            rel="noopener noreferrer"
            title={<FormattedMessage id='global.support' />}
            Icon={SupportIcon}
            className={style.icon}
          />
        </a>
      </div>
      <div className="mr-4 d-none d-sm-block">
        <Updates />
      </div>
      <div className="mr-4 d-none d-sm-block" style={{ width: 20 }}>
        <RightActions />
      </div>
      <div className="">
        <UserMenu />
      </div>
    </div>
  )
}

const mapStateToProps = ({ settings, router }) => ({
  isMenuCollapsed: settings.isMenuCollapsed,
  location: router.location
})

export default connect(mapStateToProps)(TopBar)
